module.exports = __webpack_public_path__ + "img/fb2.b8c8a4d7.png";